import React from 'react';
import moment from 'moment';

export const usersColumns = [
  { Header: 'User Name', accessor: 'name' },
  { Header: 'Email', accessor: 'email' },
  { Header: 'Phone', accessor: 'contact' },
  {
    Header: 'Created At',
    accessor: 'createdAt',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { createdAt } = payload;
      return <>{moment(createdAt).format('MMMM Do, YYYY')}</>;
    },
  },
  {
    Header: 'Updated At',
    accessor: 'updatedAt',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { updatedAt } = payload;
      return <>{moment(updatedAt).format('MMMM Do, YYYY')}</>;
    },
  },
];
